import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ReferralSourceDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  checkReferralSourceRegionExistsAsync(referralSourceId: number, regionId: any, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { referralSourceId: referralSourceId, regionId: regionId, id: id };
    return this.httpClient.getJsonAsync<boolean>('ReferralSourceRegions/CheckReferralSourceRegionExists', data, timeout, false);
  }
}
